// Sanity stores many headings in capitals; the redesigned pages use sentence case.
// Names and acronyms keep their capitals. Text that isn't all caps is returned unchanged.
const KEEP = {
  mahima: 'Mahima', bali: 'Bali', ubud: 'Ubud', sayan: 'Sayan', indonesia: 'Indonesia',
  wpt: 'WPT', itf: 'ITF', atp: 'ATP', idr: 'IDR', faq: 'FAQ', pt: 'PT',
  uri: 'Uri', sara: 'Sara', julian: 'Julian', karen: 'Karen', komang: 'Komang',
}

export default function sentenceCase(text = '') {
  const t = String(text).trim()
  if (!t || t !== t.toUpperCase()) return t
  const lower = t.toLowerCase().replace(/[a-z]+/g, (w) => KEEP[w] || w)
  return lower.charAt(0).toUpperCase() + lower.slice(1)
}
